import { Building2, Globe, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import Container from '../ui/Container';
import SectionHeading from '../ui/SectionHeading';

const features = [
  {
    icon: Globe,
    title: "Pan-African Vision",
    description: "Building a thriving Africa through strategic investments and innovation."
  },
  {
    icon: Building2,
    title: "Diverse Portfolio",
    description: "Operating across key industries including Tourism, Energy, Finance, and more."
  },
  {
    icon: Users,
    title: "People-Centric",
    description: "Empowering individuals and communities through sustainable growth."
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6
    }
  }
};

export default function FeaturesSection() {
  return (
    <section className="py-16 bg-white">
      <Container>
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <SectionHeading
            title="Why Choose BNC Africa"
            subtitle="We are committed to excellence, creating value, and driving growth across multiple sectors."
            centered
          />
        </motion.div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                variants={itemVariants}
                className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-shadow duration-300 hover:border-brown-200"
              >
                <Icon className="w-12 h-12 text-brown-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </Container>
    </section>
  );
}